import React from 'react';
import { DashboardModalsProvider } from 'framework/ui/dashboard';
import { useStaffingDashboardModals } from '../hooks/useStaffingDashboardModals';
import { getTeamDashboardModals } from '../config/dashboardModalsConfig';
import useStaffingDashboardService from '../hooks/useStaffingDashboardService';

interface StaffingDashboardModalsProviderProps {
  children: React.ReactNode;
  refetch?: () => Promise<void>;
}

const StaffingDashboardModalsProvider: React.FC<StaffingDashboardModalsProviderProps> = ({ children, refetch }) => {
  const { handleIssuesSubmit, handleFollowUpSubmit, projectData } = useStaffingDashboardModals(refetch);
  const { getFollowUpValidation } = useStaffingDashboardService();

  const modalCallbacks = {
    issues: {
      onSubmit: handleIssuesSubmit,
      onClose: () => {},
    },
    followUp: {
      onSubmit: handleFollowUpSubmit,
      onClose: () => {},
      getValidationSchema: getFollowUpValidation,
    },
    changeZone: {
      onSubmit: handleIssuesSubmit,
      onClose: () => {},
    },
  };

  const modals = getTeamDashboardModals(modalCallbacks);

  const globalData = {
    projectData,
  };

  return (
    <DashboardModalsProvider modals={modals} globalData={globalData}>
      {children}
    </DashboardModalsProvider>
  );
};

export default StaffingDashboardModalsProvider;
